<div class="resource-editor">
  <div class="resource-editor__form" *ngIf="form">
    <form [formGroup]="form">
      <div class="field-error" *ngIf="form.touched && form.errors">
        {{ form.errors?.form }}
      </div>

      <div class="field">
        <label class="field-label" for="resource-name-input">{{ 'core.resource.name' | translate }}</label>
        <input id="resource-name-input" class="ts-input" data-cy="resource-name" type="text" formControlName="name" />
        <div class="field-error" *ngIf="form.touched && form.controls['name'].errors">
          {{ 'error.field_required' | translate }}
        </div>
      </div>

      <div class="field">
        <label class="field-label" for="resource-type-select">{{ 'core.resource.type' | translate }}</label>
        <select
          id="resource-type-select"
          class="ts-selector"
          aria-label="type"
          formControlName="type"
          data-cy="resource-type"
        >
          <option [ngValue]="null" disabled hidden>{{ 'core.select' | translate }}</option>
          <option *ngFor="let type of types" [ngValue]="type">{{ type }}</option>
        </select>
        <div class="field-error" *ngIf="form.touched && form.controls['type'].errors">
          {{ 'error.field_required' | translate }}
        </div>
      </div>

      <ng-container
        *ngIf="form.value.type === 'mask' || form.value.type === 'response' || form.controls.type.status === 'DISABLED'"
      >
        <div class="field">
          <label class="field-label">{{ 'label.display_name' | translate }}</label>
          <ts-language-input [languages]="supportedLanguages" formControlName="displayName"></ts-language-input>
          <div
            class="field-error"
            *ngIf="form.touched && form.controls['displayName'].errors?.displayNameVal === 'INVALID'"
          >
            {{ 'resource_editor.errors.missing_display_name' | translate }}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="form.value.type !== null">
        <div class="field">
          <div *ngIf="preview$ | async as resourcePreview" class="flex-row justify-content-center">
            <img [src]="resourcePreview" alt="" class="resource-preview" />
          </div>

          <div class="filedrop-area flex-column align-items-center" tsFileDrop (filesDropped)="updateFile($event)">
            <p class="text-gray">
              {{ fileInput.value ? valueInput.value : ('label.drop_files_here' | translate) }}
            </p>
            <button class="btn btn-primary" type="button" (click)="fileInput.click()">
              {{ 'label.upload_files' | translate }}
            </button>
          </div>
          <input type="file" hidden #fileInput [attr.multiple]="false" (change)="updateFile($event.target.files)" />
          <div class="field-error" *ngIf="(error$ | async)?.key === 'resource_editor.errors.upload_failed'">
            {{ 'label.resource_upload_failed' | translate }}
          </div>

          <!-- Hidden mirror of the picked file's name, displayed in the drop area above. -->
          <input hidden type="text" formControlName="value" #valueInput />
        </div>
      </ng-container>

      <ng-container
        *ngIf="form.value.type === 'mask' || form.value.type === 'response' || form.controls.type.status === 'DISABLED'"
      >
        <div class="field">
          <label class="field-label" for="resource-value-input">
            <ng-container *ngIf="form.value.type === 'mask'">{{ 'core.value.mask' | translate }}</ng-container>
            <ng-container *ngIf="form.value.type === 'response' || form.controls.type.status === 'DISABLED'">{{
              'core.value.response' | translate }}</ng-container>
          </label>
          <input id="resource-value-input" class="ts-input" type="text" formControlName="label" />
        </div>
      </ng-container>

      <ng-container *ngIf="form.value.type !== 'mask' && form.value.type !== null">
        <div class="field">
          <label class="field-label" for="resource-description-input">{{ 'core.description' | translate }}</label>
          <input id="resource-description-input" class="ts-input" type="text" formControlName="description" />
        </div>
      </ng-container>

      <ng-container *ngIf="form.value.type !== null">
        <div class="field">
          <label class="field-label" for="resource-version-input">{{ 'core.version' | translate }}</label>
          <input id="resource-version-input" class="ts-input" type="number" formControlName="version" />
          <div class="field-error" *ngIf="form.touched && form.controls['version'].errors">
            {{ 'error.field_required' | translate }}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="form.value.type === 'mask'">
        <div class="field">
          <label class="field-label" for="resource-coordinates">{{ 'core.coordinates' | translate }}</label>
          <textarea
            id="resource-coordinates"
            class="ts-textarea"
            formControlName="coordinates"
            cdkTextareaAutosize
            (change)="formatConfig()"
          ></textarea>
          <div class="field-error" *ngIf="form.controls.coordinates.errors?.invalidJSON">
            {{ 'resource_editor.errors.invalid_json' | translate }}
          </div>
        </div>

        <ts-resource-manager *ngIf="showManager$ | async"></ts-resource-manager>
      </ng-container>
    </form>
  </div>

  <div *ngIf="error$ | async as error" class="resource-editor__error">
    <i class="ri-error-warning-line" aria-hidden="true"></i>
    <span>{{ error.key | translate : error.params }}</span>
  </div>

  <div class="resource-editor__actions flex-row align-items-center">
    <button
      class="btn btn-outline-danger"
      (click)="onCancel()"
      (mousedown)="$event.preventDefault()"
      type="button"
      data-cy="button-cancel-resource"
    >
      <i class="ri-close-fill"></i>
      {{ 'button.cancel' | translate }}
    </button>
    <button
      class="btn btn-primary"
      [disabled]="!form || !form.valid"
      type="button"
      data-cy="button-save-resource"
      (click)="onSave()"
    >
      <ng-template *ngIf="saving$ | async; else save">
        <i class="ri-loader-4-line spin"></i>
        {{ 'Saving' | translate }}...
      </ng-template>
      <ng-template #save>
        <i class="ri-save-line"></i>
        {{ confirmLabelKey | translate }}
      </ng-template>
    </button>
  </div>
</div>
